import React, { useEffect, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { ProductSection } from './components/ProductSection';
import { DetailsSection } from './components/DetailsSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { CheckoutSection } from './components/CheckoutSection';
import { Footer } from './components/Footer';
declare global {
  interface Window {
    fbq: (...args: any[]) => void;
    _fbq: (...args: any[]) => void;
  }
}
export function App() {
  useEffect(() => {
    // Initialize Meta Pixel
    if (!window.fbq) {
      const n: any = window.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!window._fbq) window._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
    }
    window.fbq('init', '1720113316016666');
    window.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen bg-gray-50 font-inter selection:bg-brandRed selection:text-white" data-id="element-0">
      <main data-id="element-1">
        <HeroSection data-id="element-2" />
        <ProblemSection data-id="element-3" />
        <ProductSection data-id="element-4" />
        <DetailsSection data-id="element-5" />
        <TestimonialsSection data-id="element-6" />
        <CheckoutSection data-id="element-7" />
      </main>
      <Footer data-id="element-8" />
    </div>;
}